module.exports = __webpack_public_path__ + "media/images/symbols/dark-blue-arrow-right-299c1123c8c4b4ee7b5ac27016ce38a6.svg";